import { Box, HStack } from '@chakra-ui/react';
import { Header, Table, flexRender } from '@tanstack/react-table';
import { HeaderText, TableEntry } from './Table';
import { flexProps } from './table-utils';

function TableFooter<D extends TableEntry>({
  header,
  backgroundColor,
  textColor,
}: {
  header: Header<D, unknown>;
  backgroundColor: string;
  textColor: string;
  borderColor: string;
  hoverColor: string;
  tableInstance: Table<D>;
}) {
  const footer = header.column.columnDef.footer;
  const footerContext = flexRender(footer, header.getContext());

  return (
    <Box
      role="cell"
      {...flexProps(header.column)}
      position={'relative'}
      backgroundColor={backgroundColor}
      height="100%"
      lineHeight={6}
      paddingY={1}
      paddingX={1}
    >
      {footerContext ? (
        <HeaderText isNumeric>
          <HStack justifyContent={'end'}>
            <Box color={textColor}>Total</Box>
            <Box fontWeight={'bold'}>{footerContext}</Box>
          </HStack>
        </HeaderText>
      ) : undefined}
    </Box>
  );
}

export default TableFooter;
